import { Component, OnInit } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { WorkOrderService } from 'src/app/services/work-order.service';
import { HttpClient } from '@angular/common/http';
import { DynamicForm } from '@app/model/dynamic-form';
import { ActivatedRoute, Router } from '@angular/router';
import { CromoDatosResponseDTO } from '@app/model/orden-de-trabajo-cromo.model';
import { ToastrService } from 'ngx-toastr';
import { AutocadIntegrationService } from '@app/services/autocad-integration.service';
import { AuthenticationService } from '@app/services/authentication.service';

@Component({
  selector: 'app-work-order',
  templateUrl: './work-order.component.html',
  styleUrls: ['./work-order.component.scss']
})
export class WorkOrderComponent implements OnInit {
  form = new FormGroup({});
  model = {
  };
  fields: FormlyFieldConfig[];
  formualrios : DynamicForm[];
  tipoIdSeleccionado="";
  nombreDelArchivo: string;
  ordenDeTrabajoId: string;

  mostrarArchivo: boolean=true;
  mostrarBotonArchivo: boolean=true;
  mostrarBotonAceptar: boolean=true;
  mostrarBotonEliminar: boolean=false;
  mostrarBotonCancelar: boolean=true;
  mostrarEdicionComentario: boolean=true;
  accion: string;
  dialog: string;

  submitted: boolean = false;

  constructor(
    private workOrderService:WorkOrderService,
    private router: Router,
    private http: HttpClient,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private autocadIntegrationService: AutocadIntegrationService,
    private authenticationService: AuthenticationService) {
  }
  ngOnInit(): void {
    this.accion = "";
    this.activatedRoute.queryParamMap
      .subscribe(params => {
        this.accion = "";
        let ordenDeTrabajoId = params.get('id');
        this.dialog = params.get('dialog');
        if ( ordenDeTrabajoId != null) {
          this.accion = params.get('accion');
          if(this.accion=="edicion" || this.accion=="adjuntoExistente"){
            this.mostrarBotonEliminar=true;
          }else if(this.accion=="ver"){
            this.mostrarBotonArchivo=false;
            this.mostrarBotonCancelar=false;
            this.mostrarBotonAceptar=false;
          } else if (this.accion=="adjuntoVer") {
            this.mostrarBotonArchivo = false;
            this.mostrarBotonCancelar=false;
            this.mostrarBotonAceptar=false;
          }
        }else{
          this.accion = params.get('accion') ?? "";
          console.log( 'Componente orden de trabajo ui el id es null ');
        }
        this.initForm(ordenDeTrabajoId,this.accion);
        console.log( 'Componente orden de trabajo ui con los datos iniciales '  + ordenDeTrabajoId);
      });
  }

  modelChange(): void {
    if(this.tipoIdSeleccionado!=this.model['work-order-type']){
      this.tipoIdSeleccionado=this.model['work-order-type'];
      console.log('Model Change', this.model);
      if(this.formualrios!=null){
        this.formualrios.forEach((value)=>{
          if(value.id.toString()==this.tipoIdSeleccionado){
            this._setFields(value);
          }
        });
      }
    }

  }
  uploadFile(event) {
    const fileUpload = (event.target as HTMLInputElement).files[0];
    this.form.patchValue({
      file: fileUpload
    });
    this.form.get('file').updateValueAndValidity();
    this.nombreDelArchivo = fileUpload.name;
  }

 initForm(ordenDeTrabajoId,accion): void {

  this.nombreDelArchivo = '';
  this.form = this.fb.group({
    file: [null],
  });
  console.log("getQuestionsForms test 1");
  this.ordenDeTrabajoId=ordenDeTrabajoId;
  this.workOrderService.getWorkordersForms(ordenDeTrabajoId,accion).subscribe(async data => {
   console.log("getQuestionsForms entro");
   this.formualrios = data;
   if(this.formualrios!=null && this.formualrios.length>0){
    this._setFields(this.formualrios[0]);
    //await this.setupFormData();
   }else{
     if(accion!=""){
      this.router.navigate(['/error'], { queryParams: this.activatedRoute.snapshot.queryParams});
     }
   }
 });
}

_setFields(formulario:DynamicForm){
  console.log("_setFields "+formulario.formlyFieldConfigs);
  this.fields =formulario.formlyFieldConfigs;
  this.tipoIdSeleccionado = formulario.id.toString();
  this.model["work-order-type"]=this.tipoIdSeleccionado;
  if(this.accion=="" || this.accion=="adjuntoNuevo"){
    this._setModelFromParametros();
  }


}
//?elemento_id=456434&elemento_nombre=Nombre%20del%20elemento&x=3455.45435&y=765675.435&class_id=55
  _setModelFromParametros(){
    this.activatedRoute.queryParams.subscribe(params => {
      let nombreElementoFinal = "";
      const elementoId = params['elemento_id'];
      const id = params['id'];
      let elementoNombre = params['elemento_nombre'];
      const xLocal = params['x'];
      const yLocal = params['y'];
      const latLocal = params['lat'];
      const longLocal = params['long'];
      let classId = params['class_id'];
      let className = params['class_name'];
      console.log("tiene elementoId seleccionado ",elementoId); // Print the parameter to the console.
      if ( elementoId) {
        if (elementoNombre ) {
          nombreElementoFinal = elementoNombre;
        } else {
          nombreElementoFinal = xLocal + ", "+yLocal;
        }
      } else {
        if ( xLocal && yLocal) {
          nombreElementoFinal = xLocal + ', ' + yLocal;
        }
      }
      this.model["work-order-element-selected"]=nombreElementoFinal;
      this.model["work-order-element-x"]=xLocal;
      this.model["work-order-element-y"]=yLocal;
      this.model["work-order-element-latitude"]=latLocal;
      this.model["work-order-element-longitude"]=longLocal;
      this.model["work-order-element-id"]=elementoId;
      this.model["work-order-element-class-id"]=classId;
      this.model["work-order-element-class-name"]=className;
      this.model["work-order-element-angle"]="";
      this.model["work-order-element-scale"]="";
      this.model["work-order-element-color"]="";
      this.model["work-order-id"]=id;

      console.log('nombre del elemento '+nombreElementoFinal);

  });
  }

  async setupFormData(): Promise<void> {
    this.workOrderService.getWorkordersDataForms()
      .toPromise()
      .then(data => {

        this.model = data;
        console.log("this.tipoIdSeleccionado ${this.tipoIdSeleccionado}");
        this.model['work-order-type']=this.tipoIdSeleccionado;
      });

  }
  resetForm() {
    console.log('resetForm iniciando');
    //this.model["work-order-comment"]="";
    this.form.controls[ 'work-order-comment' ].setValue('');
  }

  eliminarOrdenDeTrabajo(ordenDeTrabajoId: string) {
    //alert("eliminarOrdenDeTrabajo id "+ordenDeTrabajoId);
    this.workOrderService.eliminarOrdenDeTrabajo(ordenDeTrabajoId).subscribe(value=>{
      this.toastr.success("Nota eliminada Correctamente. ",'Finalizada');
      console.log("Se pudo eliminar la orden de trabajo");
      this.autocadIntegrationService.setNoteId(-1); //Al eliminar la nota se notifica a CromoCAD.
      this.router.navigate(['/task-success'], { queryParams: this.activatedRoute.snapshot.queryParams});

    },
    error=>{
      this.toastr.error("Hubo un problema al eliminar la nota. ",'Error');
      console.log("No se puedo crear la orden de trabajo");
    })
    ;
  }
  _createWorkOrder(){
    let file:File = this.form.get('file').value as File;
    this.workOrderService.createOrdenDeTrabajo(this.model,file).subscribe(value=>{
      this.toastr.success("Nota creada Correctamente. ",'Finalizada');
      console.log("Se creo la orden de trabajo");
      if(this.dialog!='true'){
      this.router.navigate(['/task-success'], { queryParams: this.activatedRoute.snapshot.queryParams});
      }
      
      let noteId: number = value['id'];
      console.log(`El ID de la nueva nota es ${noteId}`);
      if(noteId != null) {
        this.autocadIntegrationService.setNoteId(noteId);
      }
      
    },
    error=>{
      this.toastr.error("Hubo un problema al crear la nota. ",'Error');
      console.log("No se puedo crear la orden de trabajo "+error);

    });
  }
  _updateWorkOrder(){
    let file:File = this.form.get('file').value as File;
    this.workOrderService.updateOrdenDeTrabajo(this.model,file).subscribe(value=>{
      this.toastr.success("Nota modificada Correctamente. ",'Finalizada');
      console.log("Se puedo crear la orden de trabajo");
      if(this.dialog!='true'){
        this.router.navigate(['/task-success'], { queryParams: this.activatedRoute.snapshot.queryParams});
      }

    },
    error=>{
      this.toastr.error("Hubo un problema al modificar la nota. ",'Error');
      console.log("No se puedo crear la orden de trabajo");

    });
  }
  downloadFile($event,url){
    console.log("url de descarga "+url);
  }
  onSubmit() {
    if (this.form.valid) {
      this.submitted = true;
      if(this.accion=="" || this.accion=="adjuntoNuevo"){
        console.log("se envia la creacion de la orden de trabajo");
        this._createWorkOrder();
      }else if(this.accion=="edicion" || this.accion=="adjuntoExistente"){
        console.log("se envia la actualización de la orden de trabajo");
        this._updateWorkOrder();
      }
      console.log(JSON.stringify(this.model, null, 2)+' ARCHIVO '+this.form.get('file').value);
    }
  }
}
